<template>
  <CustomStylesApplier />
  <ILayout>
    <ILayoutHeader>
      <template v-if="meta">
        <meta v-if="meta.description" name="description" :content="meta.description" />
        <meta v-if="meta.keywords" name="keywords" :content="meta.keywords" />
        <meta v-if="meta.ogImage" property="og:image" :content="meta.ogImage" />
        <link v-if="meta.canonical_link" rel="canonical" :href="meta.canonical_link" />
        <meta v-if="meta.author" name="author" :content="meta.author" />
        <meta
          v-if="meta.publishedAt"
          property="article:published_time"
          :content="meta.publishedAt" />
        <meta v-if="meta.modifiedAt" property="article:modified_time" :content="meta.modifiedAt" />
      </template>
    </ILayoutHeader>
    <ILayoutContent class="header-bg _background:white">
      <div class="_margin-y:0 _background:white">
        <NavBar />
        <slot />
      </div>
    </ILayoutContent>
    <ILayoutFooter>
      <Footer />
      <Messages />
    </ILayoutFooter>
  </ILayout>
</template>

<script setup>
  import { computed } from 'vue'
  import NavBar from '@/Components/Landing/NavBar.vue'
  import Footer from '@/Components/Landing/Footer.vue'
  import CustomStylesApplier from '@/Components/CustomStylesApplier.vue'
  import Messages from '@/Components/Messages.vue'
  import { useMeta } from '@/Composables/useMeta'

  const props = defineProps({
    title: String,
  })

  // Set meta data
  const { metaState } = useMeta()

  // Computed property for meta data
  const meta = computed(() => metaState.value)
</script>

<style scoped>
  i-nav-item {
    cursor: pointer;
  }
</style>
